import { HttpClient } from '../HttpClient';
/**
 * * Get Tranction History Details
 **/

export const GetTransactionHistoryDetails = async ({
  PageNumber,
  RowsPerPage,
}) => {
  try {
    const response = await HttpClient.get('/api/instawage/Advances/me', {
      params: {
        PageNumber,
        RowsPerPage,
      },
    });
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
